var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#0DC9F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6335 8.85312L8.9207 10.1829L8.21926 7.75006L4.15576 6.66162L9.48882 6.93556L10.6335 8.85312Z",
    fill: "white",
    fillOpacity: 0.305
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.65186 13.496L13.8296 6.37305L14.625 8.14267L13.5815 7.85411L13.545 9.69011L4.65186 13.496Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8228 10.0013L10.1526 5.41069L3.375 5.0625L8.54044 6.44681L9.94106 11.2224L12.8228 10.0013Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32881"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWings);
export default __webpack_public_path__ + "static/media/wings.cdb9ea3e5b515289c9be281341b66316.svg";
export { ForwardRef as ReactComponent };